import { ShieldCheck, Compass, Users, Sparkles } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [ShieldCheck, Compass, Sparkles, Users];

export default function WhyChooseUs() {
  const { t } = useLang();
  const w = t.why;
  return (
    <section id="why-us" data-testid="why-us-section" className="section-y bg-white">
      <div className="container-x grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <span className="hairline" />
            <span className="text-overline">{w.overline}</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-ink-900 tracking-tight leading-tight">
            {w.h2a}{" "}
            <span className="text-brand-500">{w.h2accent}</span> {w.h2b}
          </h2>
          <p className="mt-6 text-base text-ink-500 leading-relaxed">{w.sub}</p>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-ink-900/8 border border-ink-900/8">
          {w.items.map((r, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={`why-us-${i + 1}`}
                className="bg-white p-8 sm:p-10 hover:bg-cream-50 transition-colors duration-500"
              >
                <div className="w-11 h-11 grid place-items-center bg-brand-50 text-brand-600">
                  <Icon className="w-5 h-5" strokeWidth={1.8} />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl sm:text-2xl text-ink-900">{r.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-ink-500 leading-relaxed">{r.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
